export default __webpack_public_path__ + "static/media/dumbarton.6e6f985f.jpeg";